import { useState } from 'react';
import { PAGINATION_DEFAULT_LIMIT } from 'shared/constants/paginations';

interface IPaginationParams {
  page: number;
  limit: number;
  handlePageChange: (page: number, pageSize?: number) => void;
}

interface IUseStatePaginationProps {
  defaultLimit?: number;
  pageChangeCallback?: (page: number, pageSize?: number) => void;
}

export const useStatePagination = (props?: IUseStatePaginationProps): IPaginationParams => {
  const { defaultLimit = PAGINATION_DEFAULT_LIMIT, pageChangeCallback } = props || {};
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(defaultLimit);

  const handlePageChange = (pageNumber: number, pageSize?: number) => {
    if (pageSize && pageSize !== limit) {
      setPage(pageNumber);
      setLimit(pageSize);
    } else {
      setPage(pageNumber);
    }
    if (pageChangeCallback) pageChangeCallback(pageNumber, pageSize);
  };

  return { page, limit, handlePageChange };
};
